import {LastMsgUnitModel} from './last-msg-unit.model';
import {Marker} from 'leaflet';
import {OrderModel} from './order.model';
import {ProjectModel} from './project.model';
import {EndUserPricePlanModel} from '../../unit-card/end-user-price-plan-card/end-user-price-plan.model';
import {PrepaidSharingOrderModel} from '../../prepaid-sharing-order/models/prepaid-sharing-order.model';
import {RouteLibraryEntities} from '../../route/route-library-entity';
import {
  PrepaidSharingPricePlanModel
} from '../../prepaid-sharing-price-plan/prepaid-sharing-price-plan-list/models/prepaid-sharing-price-plan.model';
import {UnitDemandModel} from './unit-demand.model';
import {BusinessLogicModel} from '../../business-logic/business-logic.model';
import {UserModel} from '../../user/user-list/user.model';

export interface UnitImagesShort {
  end_user_order_id: number;
  id: number;
  service_request_id: number;
  thumbnail: string;
  unit_status_report_id: number;
  order_finish_time: number;
}

export interface UnitModel {
  id: number;
  project_id: number;
  unit_type_name: string;
  name: string;
  description: string;
  project: ProjectModel;
  image_base64: string;
  maintenance_interval_mileage: number;
  charging_station_port01_enabled: boolean;
  charging_station_port02_enabled: boolean;
  charging_station_port03_enabled: boolean;
  charging_station_port04_enabled: boolean;
  charging_station_port01_connector_type_id: number;
  charging_station_port02_connector_type_id: number;
  charging_station_port03_connector_type_id: number;
  charging_station_port04_connector_type_id: number;
  chargingStationPort01ConnectorType: { id: number, name: string, };
  chargingStationPort02ConnectorType: { id: number, name: string, };
  chargingStationPort03ConnectorType: { id: number, name: string, };
  chargingStationPort04ConnectorType: { id: number, name: string, };
}

export class Unit {
  public static readonly STATUS_CONNECTION_ONLINE = 'online';
  public static readonly STATUS_CONNECTION_ONLINE_RECENTLY = 'online-recently';
  public static readonly STATUS_CONNECTION_ONLINE_LATELY = 'online-lately';
  public static readonly STATUS_CONNECTION_OFFLINE = 'offline';


  public static readonly GPS_COORDINATE_STATUS_OK = 'ok';
  public static readonly GPS_COORDINATE_STATUS_INVALID = 'invalid';

  public static readonly STATUS_ORDER_FREE = 'free';
  public static readonly STATUS_ORDER_IN_SERVICE = 'in_service';
  public static readonly STATUS_ORDER_BOOKED = 'booked';
  public static readonly STATUS_ORDER_ACTIVE = 'active';
  public static readonly STATUS_ORDER_PAUSED = 'paused';

  public static readonly STATUS_ORDER_GRID_FREE = 'free';
  public static readonly STATUS_ORDER_GRID_NOT_AVAILABLE = 'not_available';
  public static readonly STATUS_ORDER_GRID_BOOKED = 'booked';
  public static readonly STATUS_ORDER_GRID_ACTIVE = 'active';
  public static readonly STATUS_ORDER_GRID_PAUSED = 'paused';

  public static readonly STATUS_LAST_ORDER_FINISH_TIME_PERFECT = 'perfect';
  public static readonly STATUS_LAST_ORDER_FINISH_TIME_OK = 'ok';
  public static readonly STATUS_LAST_ORDER_FINISH_TIME_WARNING = 'warning';
  public static readonly STATUS_LAST_ORDER_FINISH_TIME_ALARM = 'alarm';


  public static readonly CHARGE_STATUS_PERFECT = 'perfect';
  public static readonly CHARGE_STATUS_OK = 'ok';
  public static readonly CHARGE_STATUS_WARNING = 'warning';
  public static readonly CHARGE_STATUS_ALARM = 'alarm';

  public static readonly UNIT_TYPE_ELECTRIC_SCOOTER = 'electric-scooter';
  public static readonly UNIT_TYPE_ELECTRIC_BIKE = 'electric-bike';
  public static readonly UNIT_TYPE_VELOMOBILE = 'velomobile';
  public static readonly UNIT_TYPE_TRICYCLE = 'tricycle';
  public static readonly UNIT_TYPE_BIKE = 'bike';
  public static readonly UNIT_TYPE_CAR = 'car';
  public static readonly UNIT_TYPE_TRACKER = 'tracker';
  public static readonly UNIT_TYPE_APARTMENT = 'apartment';
  public static readonly UNIT_TYPE_REAL_ESTATE_RENT = 'real_estate_rent';
  public static readonly UNIT_TYPE_REAL_ESTATE_PURCHASE = 'real_estate_purchase';
  public static readonly UNIT_TYPE_BABY_CARRIAGE = 'baby_carriage';
  public static readonly UNIT_TYPE_TRAILER = 'trailer';
  public static readonly UNIT_TYPE_ELECTRIC_QUAD_BIKE = 'electric_quad_bike';
  public static readonly UNIT_TYPE_CHARGING = 'charging';
  public static readonly UNIT_TYPE_ELECTRIC_MOPED = 'electric-moped';
  public static readonly UNIT_TYPE_BOAT = 'boat';
  public static readonly UNIT_TYPE_IOT = 'iot';
  public static readonly UNIT_TYPE_TRIKE = 'trike';
  public static readonly UNIT_TYPE_ELECTRIC_SNOW_SCOOTER = 'electric-snow-scooter';
  public static readonly UNIT_TYPE_MECHANICAL_BICYCLE_WITHOUT_IOT = 'mechanical-bicycle-without-iot';
  public static readonly UNIT_TYPE_ELECTRIC_BICYCLE_WITHOUT_IOT = 'electric-bicycle-without-iot';
  public static readonly UNIT_TYPE_ELECTRIC_BICYCLE_WITH_IOT = 'electric-bicycle-with-iot';

  public static readonly entityList = {
    [Unit.UNIT_TYPE_ELECTRIC_SCOOTER]: RouteLibraryEntities.ELECTRIC_SCOOTER,
    [Unit.UNIT_TYPE_ELECTRIC_BIKE]: RouteLibraryEntities.ELECTRIC_BIKE,
    [Unit.UNIT_TYPE_VELOMOBILE]: RouteLibraryEntities.VELOMOBILE,
    [Unit.UNIT_TYPE_TRICYCLE]: RouteLibraryEntities.TRICYCLE,
    [Unit.UNIT_TYPE_BIKE]: RouteLibraryEntities.BIKE,
    [Unit.UNIT_TYPE_CAR]: RouteLibraryEntities.CAR,
    [Unit.UNIT_TYPE_TRACKER]: RouteLibraryEntities.TRACKER,
    [Unit.UNIT_TYPE_BABY_CARRIAGE]: RouteLibraryEntities.BABY_CARRIAGE,
    [Unit.UNIT_TYPE_TRAILER]: RouteLibraryEntities.TRAILER,
    [Unit.UNIT_TYPE_ELECTRIC_QUAD_BIKE]: RouteLibraryEntities.ELECTRIC_QUAD_BIKE,
    [Unit.UNIT_TYPE_CHARGING]: RouteLibraryEntities.CHARGING,
    [Unit.UNIT_TYPE_ELECTRIC_MOPED]: RouteLibraryEntities.ELECTRIC_MOPED,
    [Unit.UNIT_TYPE_BOAT]: RouteLibraryEntities.BOAT,
    [Unit.UNIT_TYPE_IOT]: RouteLibraryEntities.IOT,
    [Unit.UNIT_TYPE_TRIKE]: RouteLibraryEntities.TRIKE,
    [Unit.UNIT_TYPE_ELECTRIC_SNOW_SCOOTER]: RouteLibraryEntities.ELECTRIC_SNOW_SCOOTER,
    [Unit.UNIT_TYPE_MECHANICAL_BICYCLE_WITHOUT_IOT]: RouteLibraryEntities.MECHANICAL_BICYCLE_WITHOUT_IOT,
    [Unit.UNIT_TYPE_ELECTRIC_BICYCLE_WITHOUT_IOT]: RouteLibraryEntities.ELECTRIC_BICYCLE_WITHOUT_IOT,
    [Unit.UNIT_TYPE_ELECTRIC_BICYCLE_WITH_IOT]: RouteLibraryEntities.ELECTRIC_BICYCLE_WITH_IOT,
  };

  public static readonly SATELLITE_ALARM = 2;
  public static readonly SATELLITE_WARNING = 7;
  public static readonly SATELLITE_NORMAL = 10;

  id: number;
  name: string;
  unit_model_name: string;
  hw_id: string;
  hw_type: string;
  integrator_id: number;
  integrator_login: string;
  admin_id: number;
  admin_login: string;
  phone: string;
  layer: Marker = null;
  chargeStatus: 'alarm' | 'warning' | 'ok' | 'perfect';
  gpsCoordinateStatus: 'ok' | 'invalid';
  lastMsgUnit: LastMsgUnitModel = null;
  lastFinishedOrder: OrderModel = null;
  lastFinishedOrCancelledOrder: OrderModel = null;
  project_custom_name: string;
  ordersCount: number;
  ordersPrice: number;
  unitType: {
    name: string,
    description: string
  } = null;
  unitModel: UnitModel = null;
  hwModel: {
    name: string;
    description: string;
    hw_type: string;
    unit_type: string;
    lock_type: string;
    battery_mount_type: string;
    project_id: number;
  };
  unitStatus: {
    name: string;
  };
  statusCombined: string;
  activeOrder: OrderModel | null;
  activePrepaidSharingOrder: PrepaidSharingOrderModel | null;
  status: 'offline' | 'online_ready' | 'online_active_trip';
  charge: string;
  sats = null;
  height = null;
  gsm = null;
  mileage: string;
  plate_number: string;
  registration_number: string;
  color_name: string;
  address: string;
  html_color: string;
  assigned_to_end_user_id: number;
  status_connection: 'online' | 'offline' | 'online-recently' | 'online-lately';
  status_order: 'free' | 'in_service' | 'booked' | 'active' | 'paused';
  monitoring_module_attachment_type_id: number;
  status_order_grid: string;
  unit_type_name: string;
  unit_model_id: number;
  unit_status_id: number;
  endUserPricePlans: Array<EndUserPricePlanModel>;
  showInApplication: boolean;
  availabilityStatus: Array<string>;
  lbsCellId: number;
  lbsCountryCode: number;
  lbsLac: number;
  lbsOperatorId: number;
  gpsIsOnline: boolean;
  inRideAllowArea: boolean;
  inFinishAllowArea: boolean;
  scooter_status: string;
  lastOrderFinishTimeStatus: 'perfect' | 'ok' | 'warning' | 'alarm';
  hoursPassedSinceLastOrder: number;
  last_maintenance_mileage: number;
  region_from_unit_setting_name: string;
  region_error: boolean;
  countryNameFromUnitSettings: string;
  country_error: boolean;
  battery: {
    id: number,
    name: string,
    admin_id: number,
    integrator_id: number,
    rent_to_integrator_id: number,
    removed_at: string,
    attached_to_unit_id: number,
    serial_number: string,
    registration_number: string,
    charge_before_detach: number,
    last_action_type: string,
    last_action_typelast_action_time: string,
    last_action_user_id: number,
    charge: number,
    trackerCharge: number,
    attachedTrackerStatus: string,
    attachedTrackerId: number,
    attachedTrackerName: string,
    lastActionUserLogin: string,
    lastActionTimestamp: number,
  } = null;
  attachedUnit: {
    id: number,
    name: string,
  } = null;
  attachedToUnit: {
    id: number,
    name: string,
  } = null;
  attachedToBattery: {
    id: number,
    name: string,
  } = null;
  prepaidSharingWebAppUrl: string;
  prepaidPricePlans: PrepaidSharingPricePlanModel[];
  unitDemands: UnitDemandModel[];
  calculatedPassword: string;
  businessLogics: BusinessLogicModel[];
  writtenOffByUser: UserModel;
  written_off: boolean;
  write_off_comment: string;
  written_off_at_timestamp: number;
  legal_entity_id: number;
  branch_office_id: number;
  model_access_rights?: {[key: string]: boolean};

  public static chargeIsAlarm(unit) {
    return unit.chargeStatus === Unit.CHARGE_STATUS_ALARM;
  }

  public static chargeIsWarning(unit) {
    return unit.chargeStatus === Unit.CHARGE_STATUS_WARNING;
  }

  public static chargeIsOk(unit) {
    return unit.chargeStatus === Unit.CHARGE_STATUS_OK;
  }

  public static chargeIsPerfect(unit) {
    return unit.chargeStatus === Unit.CHARGE_STATUS_PERFECT;
  }

  public static gpsCoordinateStatusIsOk(unit) {
    return unit.gpsCoordinateStatus === 'ok';
  }

  public static gpsCoordinateStatusIsInvalid(unit) {
    return unit.gpsCoordinateStatus === 'invalid';
  }
}
